import { render, staticRenderFns } from "./AcademicJournalCollectedPapers.vue?vue&type=template&id=6b4942cf&scoped=true"
import script from "./AcademicJournalCollectedPapers.vue?vue&type=script&lang=js"
export * from "./AcademicJournalCollectedPapers.vue?vue&type=script&lang=js"
import style0 from "./AcademicJournalCollectedPapers.vue?vue&type=style&index=0&id=6b4942cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4942cf",
  null
  
)

export default component.exports